module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-header"
  }, [_c('div', {
    staticClass: "header-content"
  }, [_c('span', {
    staticClass: "header-label"
  }, [_vm._v("PANEL PRINCIPAL")]), _c('h1', [_vm._v("Buenos días, " + _vm._s(_vm.nombre))]), _c('p', [_vm._v("Aquí tienes el resumen de tus actividades y pendientes.")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d53935a","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kpis/dashboard/c_dashboard_header.vue
// module id = 886
// module chunks = 0